exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-wrap.permanent[data-v-18090a2b] {\n  height: 0px;\n  min-height: 0px !important;\n}\n", ""]);

// exports
